import axios from 'axios';
import { KlydoUnion } from './klydo';
import { baseUrl } from './baseRequest';

export type KlydoPreview = Pick<KlydoUnion, 'id' | 'loopUrl' | 'theme'>;

export type PublicApiClient = {
  getKlydo: (id: string) => Promise<KlydoPreview>;
};

export const publicClient = {
  get: async <T>({
    url,
    params,
  }: {
    url: string;
    params?: object;
  }): Promise<T> => {
    return axios.get(baseUrl + url, { params }).then((res) => res.data);
  },
};

const publicApiClient: PublicApiClient = {
  getKlydo: (id: string) => {
    return publicClient.get<KlydoPreview>({
      url: `/public/klydo-preview/${id}`,
    });
  },
};

export default publicApiClient;
